import React from 'react';
import Modal from '../../components/UI/Modal';
import './DeviceDetailsModal.css';

const DeviceDetailsModal = ({ isOpen, onClose, devices, userName }) => {
  if (!isOpen) return null;

  return (
    <Modal title={`Devices for ${userName}`} onClose={onClose}>
      <div className="device-details-content">
        {devices && devices.length > 0 ? (
          <div className="device-list">
            {devices.map((device, index) => (
              <div key={device.SerialNumber || index} className="device-item">
                <div className="device-serial">
                  <strong>{device.SerialNumber}</strong>
                </div>
                <div className="device-info">
                  <span className="device-name">{device.DeviceName}</span>
                  <span className="device-type">{device.DeviceName}</span>
                </div>
                <div className="device-status">
                  <span className={device.Status?.toLowerCase() === 'active' ? 'active-badge' : 'inactive-badge'}>
                    {device.Status || 'Inactive'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-devices">
            <p>No devices found for this user.</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DeviceDetailsModal;